module.exports = __webpack_public_path__ + "img/soprasteria.aa41dc7d.jpg";